import React from 'react';
import _ from 'lodash';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import img from './rocket.png';
import preloadImg from '../../lib/util/preload-img';
import Icon from '../icon/icon';
import { LOG_IN_ROUTE } from '../../constants/constants';

preloadImg(img);

class ExistingAppointment extends React.Component {
	componentDidMount () {
		if (_.isEmpty(this.props.inspectionRequest)) {
			this.props.setRoute(LOG_IN_ROUTE);
		} else {
			this.props.setParentState({
				progressIndex: -1,
				canLogOut: false,
				canGoToHomePage: true
			});
		}
	}

	render () {
		if (_.isEmpty(this.props.inspectionRequest)) {
			return (<div />);
		}

		const __ = mergeI18n(this.props.language, i18n);
		document.title = `${__.titleStem} - ${__.pageTitle}`;

		return (
			<div id='lss-content' className='container'>
				<div className='row'>
					<div className='col-xs-12'>
						<div id='existing-appointment'>
							<div className='row'>
								<div className='col-xs-12 col-centered text-center'>
									<img className='rocket-icon' src={img} alt='' />
									<h2 className='lss-blue'>{__.alreadyScheduled}</h2>
									<h3 id='confirmationNo'>{__.confirmationNo(this.props.inspectionRequest.confirmationNo)}</h3>
									<h4 id='dateTime'>{__.dateTime(this.props.inspectionRequest.activeAppointments[0])}</h4>
									<h4 id='apptLocation'>{__.apptLocation(this.props.inspectionRequest.activeAppointments[0].location)}</h4>
									<h5>{__.pleaseContact}</h5>
								</div>
							</div>
							<div className='col-centered text-center contact-row'>
								<div className='contact-row row col-centered text-center'>
									<div className='contact-container'>
										<span className='link-wrapper'>
											<Icon name='MdPhone' />
											<a href={`tel:${__.callCenterPhone.replace(/\D/g, '')}`}>{__.callCenterPhone}</a>
										</span>
										<span className='link-wrapper'>
											<Icon name='MdEmail' />
											<a href={`mailto:${__.callCenterEmail}`}>{__.callCenterEmail}</a>
										</span>
									</div>
									<p id='callCenterHours' className='hours lss-dark-grey'>{__.callCenterHours}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

ExistingAppointment.propTypes = {
	inspectionRequest: propTypes.shape({
		lesseeFirstName: propTypes.string,
		lesseeLastName: propTypes.string,
		lesseeEmail: propTypes.string,
		vehicles: propTypes.arrayOf(propTypes.shape({
			vin: propTypes.string.isRequired,
			make: propTypes.string,
			model: propTypes.string,
			year: propTypes.string
		}))
	}),
	language: propTypes.string.isRequired
};
export default ExistingAppointment;
